import { Divider } from '@mui/material';

import { Strings } from '@app/constants';
import Compensation from './compensation';
import { Header } from '@app/sections/header';
import { useDialog, useRequestState } from '@app/hooks';
import AddNewCompensation from './add-new-compensation';
import { selectAddCompensationState } from '../selectors';

const CompensationPage = () => {
  const addCompensationDialog = useDialog();

  const { data } = useRequestState({
    stateSelector: selectAddCompensationState,
    errorShown: true,
  });

  return (
    <>
      <Header
        title={Strings.page_title.compensationLetter}
        helperText={''}
        actionButtonTitle={Strings.button.addNew}
        onClickActionButton={addCompensationDialog.show}
      />
      <Divider />
      <Compensation data={data} />
      {addCompensationDialog.visible && (
        <AddNewCompensation
          open={addCompensationDialog.visible}
          onClose={addCompensationDialog.hide}
        />
      )}
    </>
  );
};

export { CompensationPage };
